import GetLoggedInSateModel from '../../App/Models/GetLoggedInSate.interface';
import Fetcher from '../Common/Fetcher';
import UserState from '../Models/UserState.interface';

let abortController: AbortController = new AbortController();

function FetchUserState(url: string, litiumContext: string) {
  abortController.abort();
  abortController = new AbortController();
  const signal = abortController.signal;
  return Fetcher<UserState, GetLoggedInSateModel>(
    url,
    signal,
    (res, resolve, reject) => {
      if (res.success) {
        resolve(res.userState);
      }
      resolve({} as UserState);
    },
    litiumContext
  );
}

export default FetchUserState;
